import { type CombinedLeadAttributeValueType } from '@app/queries/lead/lead';
import { type TransformedLeadAttribute } from '@app/services/lead/leadAttributesService';
import { type TransformedTaskttribute } from '@app/services/task/taskAttributesService';
import { leadStagesSelector } from '@repo/config-services';
import { Tag } from 'antd';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

function ProspectStageTagRenderer({
  leadStage,
}: {
  leadStage?: TransformedLeadAttribute | TransformedTaskttribute | CombinedLeadAttributeValueType
}) {
  const leadStages = useSelector(leadStagesSelector);
  const leadStageOption = useMemo(() => leadStages?.find(
    (stage) => stage.value === leadStage?.value,
  ), [leadStages, leadStage]);

  return (
    <Tag color={leadStageOption?.config?.colorScheme ?? 'default'}>
      {leadStageOption?.label || (leadStage as TransformedLeadAttribute)?.displayValue || leadStage?.value}
    </Tag>
  );
}

export default React.memo(
  ProspectStageTagRenderer,
  (prevProps, nextProps) => prevProps.leadStage?.value === nextProps.leadStage?.value,
);
